<template>
  <div>
    <v-container>
      <!-- approved earlier, now not shown on the site: no "under review" text -->
      <div v-if="!user.active && user.approved">
        <v-card class="pa-6">
          <p class="title">
            {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.welcomeMessage.hello") }}
            {{ user.name }}
            {{ user.middle_name }}!
          </p>
          <p class="mb-0">
            {{ $vuetify.lang.t(user.archived_payable ? "$vuetify.main.psychologistDashboard.stats.archivedPay" : "$vuetify.main.psychologistDashboard.stats.deactivated") }}
          </p>
        </v-card>
      </div>
      <div v-else-if="!this.user.active">
        <v-card class="pa-6">
          <p class="title">
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.hello"
              )
            }}
            {{ this.user.name }}
            {{ this.user.middle_name }}!
          </p>
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.title"
              )
            }}
          </p>
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.subtitle"
              )
            }}
          </p>
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.description"
              )
            }}
          </p>
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.informing"
              )
            }}
          </p>
        </v-card>
      </div>
      <div class="d-flex flex-column align-center" v-if="this.user.active">
        <h1>
          {{
            $vuetify.lang.t("$vuetify.view.auth.psychologist.Schedule.title")
          }}
        </h1>
        <p>
          {{
            $vuetify.lang.t("$vuetify.view.auth.psychologist.Schedule.subtitle")
          }}
        </p>
      </div>
      <GoogleCalendarSync
        v-if="this.user.active"
        class="mt-6"
        @change="googleConnected = $event"
        @synced="reloadSlots"
      />
      <template v-if="this.user.active">
        <div class="d-flex date-time-picker">
          <div>
            <v-row>
              <v-col cols="12" md="12">
                <div class="date-picker__wrapper">
                  <v-date-picker
                    v-model="selectedDate"
                    :allowed-dates="allowedDates"
                    full-width
                    class="mt-4"
                    :min="minDate"
                    :max="maxDate"
                    color="primary"
                    header-color="primary"
                    :events="eventsArray"
                    event-color="primary"
                    :first-day-of-week="1"
                  ></v-date-picker>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="slots__wrapper">
            <div
              class="d-flex flex-column mt-5"
              v-for="(items, i) in timeSlots"
              v-bind:key="i"
              :class="{
                'invisible': convertDate(items.date.value) != selectedDate,
              }"
            >
              <p class="title">{{ items.date.translated }}</p>
              <div class="d-flex flex-row flex-wrap justify-start">
                <div v-for="(item, n) in items.slots" v-bind:key="n">
                  <v-tooltip
                    :open-on-hover="item.is_booked"
                    :open-on-click="false"
                    :open-on-focus="false"
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="ma-5" v-on="on" v-bind="attrs">
                        <v-btn
                          :disabled="initialDisabledBtn(item)"
                          class="btn-disable"
                          :class="initialBtnColor(item)"
                          @click="changeBtnsValue(items, i, n, $event)"
                          v-bind:key="item.id"
                          outlined
                          >{{ item.time }}</v-btn
                        >
                      </div>
                    </template>
                    <span v-show="item.patient_name"
                      >{{
                        $vuetify.lang.t(
                          "$vuetify.main.psychologistDashboard.schedule.client"
                        )
                      }}
                      {{ item.patient_name }}</span
                    >
                  </v-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="d-flex justify-end" v-if="this.user.active && !googleConnected">
        <v-btn
          v-if="!isBtnVisible"
          @click="isBtnVisible = !isBtnVisible"
          outlined
          color="primary"
          >{{
            $vuetify.lang.t("$vuetify.view.auth.psychologist.Schedule.btnEdit")
          }}</v-btn
        >
        <v-btn
          v-if="isBtnVisible"
          @click="dataToSave()"
          outlined
          color="success"
          >{{
            $vuetify.lang.t("$vuetify.view.auth.psychologist.Schedule.btnSave")
          }}</v-btn
        >
      </div>
      <template v-if="this.user.active">
        <v-row justify="center">
          <h1>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.schedule.instruction"
              )
            }}
          </h1>
        </v-row>
        <div class="d-flex flex-column align-start">
          <div class="d-flex flex-row flex-wrap ma-5">
            <v-btn class="btn-disabled" outlined>
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistDashboard.schedule.example1"
                )
              }}</v-btn
            >
            <span class="align-self-center ml-5 font-weight-light"
              >{{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistDashboard.schedule.exampleDesk11"
                )
              }}<span class="font-weight-bold">
                {{
                  $vuetify.lang.t(
                    "$vuetify.main.psychologistDashboard.schedule.exampleDesk12"
                  )
                }}</span
              >
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistDashboard.schedule.exampleDesk13"
                )
              }}</span
            >
          </div>
          <div class="d-flex flex-row flex-wrap ma-5">
            <v-btn class="active">
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistDashboard.schedule.example2"
                )
              }}
            </v-btn>
            <span class="align-self-center ml-5 font-weight-light"
              >{{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistDashboard.schedule.exampleDesk21"
                )
              }}
              <span class="font-weight-bold">{{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistDashboard.schedule.exampleDesk22"
                )
              }}</span>
              {{
                $vuetify.lang.t(
                  "$vuetify.main.psychologistDashboard.schedule.exampleDesk23"
                )
              }}</span
            >
          </div>
          <div class="schedule-calendar-note ma-5">
            <p class="font-weight-bold mb-3">
              {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.schedule.calendarTitle") }}
            </p>
            <p class="mb-3">
              {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.schedule.calendarText") }}
            </p>
            <p class="font-italic mb-0">
              {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.schedule.calendarCta") }}
            </p>
          </div>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import GoogleCalendarSync from "./GoogleCalendarSync";

export default {
  name: "Schedule",
  components: { GoogleCalendarSync },
  metaInfo() {
    return {
      title:
        "Платформа / " +
        this.$vuetify.lang.t("$vuetify.main.header.menu.schedule"),
    };
  },
  data() {
    return {
      selectedDate: null,
      prevBtn: null,
      isBtnVisible: false,
      timeSlots: [],
      activeSlots: [],
      isBookedSlots: [],
      isBookedEdited: false,
      isActiveEdited: false,
      pole: "",
      selectedSlotConsultationId: null,
      // hours come from Google Calendar: manual editing is off
      googleConnected: !!this.$store.getters["user/getUser"].google_calendar_connected,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
    eventsArray() {
      let array = [];
      this.timeSlots.forEach((el) => {
        let hasBookedSlots = false;
        el.slots.forEach((slot) => {
          if (slot.is_booked) {
            hasBookedSlots = true; 
          }
        });

        if (hasBookedSlots) {
          array.push(this.convertDate(el.date.value));
        }
      });
      return array;
    },
    allowedDatesArray() {
      let array = [];
      this.timeSlots.forEach((el) => {
        array.push(this.convertDate(el.date.value));
      });
      return array;
    },
    minDate() {
      return this.allowedDatesArray.length
        ? this.allowedDatesArray.reduce((a, b) => a < b ? a : b)
        : null;
    },
    maxDate() {
      return this.allowedDatesArray.length
        ? this.allowedDatesArray.reduce((a, b) => a > b ? a : b)
        : null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.selectedDate = this.minDate;
    });
  },
  beforeCreate() {
    this.$store.dispatch("user/getProfile", {});
  },
  beforeMount() {
    this.initSlots();
  },
  methods: {
    reloadSlots() {
      this.$store.dispatch("user/getProfile", {}).then(() => {
        this.initSlots();
        this.isBtnVisible = false;
      });
    },
    initSlots() {
    this.timeSlots = this.user.time_slots;
    this.isBookedSlots = [];
    this.activeSlots = [];

    this.user.time_slots.map((item) => {
      item.slots.map((slot) => {
        if (slot.is_booked) {
          this.isBookedSlots.push({
            ids: slot.id,
          });
        }

        if (slot.available && !slot.is_booked) {
          this.activeSlots.push({
            ids: slot.id,
          });
        }
      });
    });
    },
    convertDate(val) {
      const [day, month, year] = val.trim().split('.');
      return `${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`;
    },
    allowedDates(val) {
      return this.allowedDatesArray.includes(val);
    },
    getPayload(options) {
      let payload = [];

      switch (options) {
        case "available":
          this.activeSlots.map((el) => {
            payload.push(el.ids);
          });
          return payload;
        case "booked":
          return this.selectedSlotConsultationId;
      }
    },
    async dataToSave() {
      this.isBtnVisible = !this.isBtnVisible;

      await this.$store
        .dispatch("user/allowTimeSlotByPsyh", {
          ids: this.getPayload("available"),
        })
        .then((response) => {
          if (response.status === 200) {
            Vue.swal({
              target: document.getElementById("main"),
              text: response.data.message,
              icon: "success",
              timer: 4000,
              toast: true,
              position: "top-right",
              showConfirmButton: false,
            });
            this.$store.dispatch("user/getProfile", {});
          }
        });
    },
    async changeBtnsValue(items, indexFromUserSelect, itemIndex, event) {
      let available = items.slots[itemIndex].available;
      let is_booked = items.slots[itemIndex].is_booked;
      this.selectedSlotConsultationId = items.slots[itemIndex].consultation_id;
      this.setActiveSlot(items.slots[itemIndex], false);

      if (is_booked) {
        Vue.swal({
          target: document.getElementById("app"),
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.schedule.swallCancelSessionByPsychologistTitle"
          ),
          showDenyButton: true,
          confirmButtonText: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.schedule.swallYes"
          ),
          denyButtonText: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.schedule.swallNo"
          ),
        }).then(async (result) => {
          if (result.isConfirmed) {
            Vue.swal({
              target: document.getElementById("main"),
              text: this.$vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.schedule.swallCancelSessionByPsychologist"
              ),
              toast: true,
              position: "top-right",
              showConfirmButton: false,
              didOpen: () => {
                Vue.swal.showLoading();
              },
              didClose: () => {},
            });
            let consultationId = this.getPayload("booked");
            await this.$store
              .dispatch("user/cancelConsultationByPsyh", {
                id: consultationId,
              })
              .then((response) => {
                if (response.status === 200) {
                  Vue.swal({
                    target: document.getElementById("main"),
                    text: response.data.message,
                    icon: "success",
                    timer: 4000,
                    toast: true,
                    position: "top-right",
                    showConfirmButton: false,
                  });

                  this.timeSlots[indexFromUserSelect].slots.forEach((slot, index) => {
                    if (slot.consultation_id == consultationId) {
                      this.setActiveSlot(items.slots[index], true);

                      Object.assign(
                        this.timeSlots[indexFromUserSelect].slots[index],
                        {
                          is_booked: false,
                          available: true,
                          patient_name: "",
                        }
                      );
                    }
                  });

                  this.changeBtnColorScheme(items, event);
                  this.isBtnVisible = !this.isBtnVisible;
                  this.$store.dispatch("user/getProfile", {});
                } else {
                  Vue.swal({
                    target: document.getElementById("main"),
                    text: response.data.message,
                    icon: "error",
                    timer: 4000,
                    toast: true,
                    position: "top-right",
                    showConfirmButton: false,
                  });
                }
              });
          }

          if (result.isDenied) {
            Object.assign(
              this.timeSlots[indexFromUserSelect].slots[itemIndex],
              {
                is_booked: true,
                available: false,
                patient_name: items.slots[itemIndex].patient_name,
              }
            );
          }
        });
      }

      if ((available && !available) || !is_booked) {
        Object.assign(this.timeSlots[indexFromUserSelect].slots[itemIndex], {
          available: !available,
        });
        this.changeBtnColorScheme(items, event);
      }
    },
    changeBtnColorScheme(item, event) {
      if (event.target.tagName === "SPAN") {
        this.prevBtn = event.target.parentElement;

        if (
          event.target.parentElement.classList.contains("active-btn--green")
        ) {
          return event.target.parentElement.classList.toggle(
            "active-btn--green"
          );
        } else if (event.target.parentElement.classList.contains("active")) {
          return event.target.parentElement.classList.toggle("active");
        } else {
          return event.target.parentElement.classList.toggle("active");
        }
      } else {
        this.prevBtn = event.target;

        if (event.target.classList.contains("active-btn--green")) {
          return event.target.classList.toggle("active-btn--green");
        } else if (event.target.classList.contains("active")) {
          return event.target.classList.toggle("active");
        } else {
          return event.target.classList.toggle("active");
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    setActiveSlot(item, isBooked) {
      if (item.is_booked && item.psychologist_can_cancel && isBooked) {
        if (
          this.isBookedSlots.find((el) => {
            return el.ids === item.id;
          })
        ) {
          this.isBookedSlots = this.isBookedSlots.filter((el) => {
            el.ids !== item.id;
          });

          return this.activeSlots.push({
            ids: item.id,
          });
        } else {
          this.isBookedSlots.push({
            ids: item.id,
          });
        }
      }

      if (
        this.activeSlots.find((el) => {
          return el.ids === item.id;
        })
      ) {
        this.activeSlots = this.activeSlots.filter((el) => {
          return el.ids !== item.id;
        });
      } else {
        if (item.is_booked) {
          return;
        } else {
          this.activeSlots.push({
            ids: item.id,
          });
        }
      }
    },
    initialBtnColor(item) {
      if (item.is_booked && item.psychologist_can_cancel) {
        return "active-btn--green";
      } else if (item.available && !item.is_booked) {
        return "active";
      } else if (item.is_booked && !item.psychologist_can_cancel) {
        return "custom-btn";
      } else {
        return "";
      }
    },
    initialDisabledBtn(item) {
      if (this.isBtnVisible) {
        if (!item.psychologist_can_cancel && item.is_booked) {
          return !item.psychologist_can_cancel;
        }
      }
      return !this.isBtnVisible;
    },
  },
};
</script>

<style scoped>
.date-time-picker {
  flex-wrap: wrap;
  column-gap: 30px;
}

@media screen and (max-width: 1263px) {
  .date-time-picker {
    flex-wrap: wrap;
    column-gap: 16px;
  }
}

.invisible {
  overflow: hidden;
  height: 0px;
  margin-top: 0px !important;
}

.slots__wrapper {
  flex-basis: 370px;
  flex-grow: 1;
}

.date-picker__wrapper {
  max-width: 320px;
  /* max-width: 100%; */
}

.date-picker__wrapper ::v-deep(.v-picker__title) {
  padding: 8px 12px;
}

.date-picker__wrapper ::v-deep(.v-date-picker-title__date) {
  font-size: 18px;
}

.date-picker__wrapper ::v-deep(.v-date-picker-title__year) {
  margin-bottom: 1px;
}
</style>

<style lang="sass" scoped>
.btn-disable
  color: #1B1B1B

.active
  color: #989898 !important
  background-color: #C4C4C4 !important

.active-btn--green
  color: #ffffff !important
  background-color: #00A4B7 !important

.custom-btn
  color: #ffffff
  background-color: #003D44 !important
#black-btn
  color: #ffffff !important
</style>
